import { useSelector } from 'react-redux';
import type { VFC } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../redux/savedFilters/hooks';
import { Icon, icons } from '../../generic';
import DropdownButton from '../../generic/DropdownButton';

import useFetchIssuesAction from './hooks/useFetchIssuesAction';

const groupingLabels = {
  // Note: these need to be wrapped in a span instead of a fragment because the
  // container has a flexbox that spreads the items in the dropdown.
  issue: (
    <span>
      <Icon icon={icons.list} /> Ungrouped
    </span>
  ),
  revision: (
    <span>
      <Icon icon={icons.listTree} /> Version
    </span>
  ),
};

const groupingOptions = Object.keys(groupingLabels) as Array<keyof typeof groupingLabels>;

/**
 * A dropdown to select the grouping of issues.  Triggers a reload of issues
 * when the grouping changes.
 */
const IssuesGroupingDropdown: VFC = () => {
  const grouping = useSelector(IssuesV2Store.selectors.getGrouping);
  const setGrouping = useFetchIssuesAction(IssuesV2Store.actions.setGrouping);
  const setHasChanged = useSetFilterHasChanged();
  return (
    <div className="issues-dropdown" data-test-id="issues-grouping-dropdown">
      <DropdownButton
        id="IssuesGroupingDropdown"
        title={groupingLabels[grouping]}
        onSelect={(...args: unknown[]) => {
          setGrouping(...args);
          setHasChanged(true);
        }}
        size="medium"
      >
        {groupingOptions.map(labelKey => (
          <DropdownButton.Item
            key={labelKey}
            eventKey={labelKey}
            active={labelKey === grouping}
          >
            {groupingLabels[labelKey]}
          </DropdownButton.Item>
        ))}
      </DropdownButton>
    </div>
  );
};

export default IssuesGroupingDropdown;
